import { GET_CATEGORY_GROUP } from '../config';

export default function (state = [], action) {
    switch (action.type) {
        case GET_CATEGORY_GROUP:
            return action.payload;
        default:
            return state;
    }
}
